
    <div class="row m-b-md header-row">
        <div class="col-sm-12">
            <b>Report Generator</b>
        </div>
    </div>
    <hr class="splitter">
    <div class="content-area flex-fill">
        <form #form="ngForm" submittable autocomplete="off" class="h-100 d-flex flex-column">
            <div class="flex-fill form-constructor-overview">
            <div class="form-constructor">
            <div class="row m-b-sm">
                <div class="col-md-3 input-header">Report Name</div>
                <div class="col-md-5 input-header">Description</div>
                <div class="col-md-2 input-header">Section</div>
                <!--<div class="col-md-2 input-header">Type</div>-->
            </div>
            <div class="row" style="padding-bottom: 40px;">
                <div class="col-md-3">
                    <input class="form-control"
                           name="reportName"
                           [(ngModel)]="data.name"
                           required
                           (change)="reportGeneratorService.modalInfoWasChanged = true;"
                           maxlength="255"
                           [disabled]="reportGeneratorService.viewOnlyMode">
                </div>
                <div class="col-md-5">
                    <input class="form-control"
                           name="description"
                           [(ngModel)]="data.description"
                           (change)="reportGeneratorService.modalInfoWasChanged = true;"
                           maxlength="255"
                           [disabled]="reportGeneratorService.viewOnlyMode">
                </div>
                <div class="col-md-2">
                    <select class="form-control"
                            name="section"
                            [(ngModel)]="data.section"
                            (change)="onSectionChange($event)"
                            required
                            [disabled]="reportGeneratorService.viewOnlyMode">
                        <option value="" hidden></option>
                        <option *ngFor="let section of sections" [value]="section.id">{{section.name}}</option>
                    </select>
                </div>
                <!--<div class="col-md-2">-->
                    <!--<select class="form-control" name="type" [(ngModel)]="data.type">-->
                        <!--<option value="" hidden></option>-->
                        <!--<option value="frequency">Frequency Report</option>-->
                        <!--<option value="list">List Report</option>-->
                    <!--</select>-->
                <!--</div>-->
            </div>
            <div class="report-info" *ngIf="data.section">
                <div class="row m-b-sm">
                    <div class="col-md-12 input-header">
                        Fields
                        <button type="submit"
                                class="btn btn-primary submit-btn show-all-button"
                                [disabled]="chosenSection.fields.length < 1 || reportGeneratorService.viewOnlyMode"
                                (click)="showAllFields()">
                            Show All
                        </button>
                    </div>
                </div>

                <ul class="m-b-md drag-and-drop-row" [dragula]="'bag-fields'" [dragulaModel]="chosenSection.fields">
                    <li *ngFor="let field of chosenSection.fields" class="field-item">{{field.name}}</li>
                </ul>

                <div class="row m-b-sm">
                    <div class="col-md-12 input-header">Show</div>
                </div>

                <ul class="m-b-md drag-and-drop-row" [dragula]="'bag-fields'" [dragulaModel]="data.fieldsToShow">
                    <li *ngFor="let field of data.fieldsToShow" class="field-item">{{field.name}}</li>
                </ul>

                <div class="row m-b-sm">
                    <div class="col-md-12 input-header">Group By</div>
                </div>

                <ul class="m-b-md drag-and-drop-row" [dragula]="'bag-fields'" [dragulaModel]="data.groupBy">
                    <li *ngFor="let field of data.groupBy" class="field-item">{{field.name}}</li>
                </ul>

                <div class="row m-b-sm" *ngIf="data.type == 'frequency'">
                    <div class="col-md-3 input-header">Frequency Settings</div>
                    <div class="col-md-9">
                        <div class="col-md-3 input-header">Sort By</div>
                        <div class="col-md-3 input-header">Sort By Direction</div>
                        <div class="col-md-3 input-header">Page Orientation</div>
                        <div class="col-md-3 input-header">Graph</div>
                    </div>
                </div>

                <div class="row m-b-md" *ngIf="data.type == 'frequency'">
                    <div class="col-md-3 remove-children-p-l" style="padding-right: 0;">
                        <div class="col-md-6">
                            <select class="form-control"
                                    name="frequencySettings"
                                    [disabled]="reportGeneratorService.viewOnlyMode">
                                <option value="" hidden></option>
                                <option>Frequency Settings</option>
                                <!--<option *ngFor="let build of dailyReportsService.buildingsForUpdate" [value]="build.id">{{build.name}}</option>-->
                            </select>
                        </div>
                        <div class="col-md-3">
                            <input class="form-control" name="from" placeholder="From">
                        </div>
                        <div class="col-md-3">
                            <input class="form-control" name="to" placeholder="To">
                        </div>
                    </div>
                    <div class="col-md-9" style="padding: 0;">
                        <div class="col-md-3">
                            <select class="form-control"
                                    name="orderBy"
                                    [(ngModel)]="data.orderBy"
                                    required
                                    [disabled]="reportGeneratorService.viewOnlyMode">
                                <option value="" hidden></option>
                                <option *ngFor="let field of data.fieldsToShow" [value]="field.key">{{field.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <select class="form-control"
                                    name="orderByDirection"
                                    [(ngModel)]="data.orderByDirection"
                                    required
                                    [disabled]="reportGeneratorService.viewOnlyMode">
                                <option value="asc">Ascending</option>
                                <option value="desc">Descending</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <select class="form-control" name="pageOrientation" [disabled]="reportGeneratorService.viewOnlyMode">
                                <option value="" hidden></option>
                                <option value="landscape">Landscape</option>
                                <option value="portrait">Portrait</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <select class="form-control" name="graph" [disabled]="reportGeneratorService.viewOnlyMode">
                                <option value="" hidden></option>
                                <option>Graph</option>
                                <!--<option *ngFor="let build of dailyReportsService.buildingsForUpdate" [value]="build.id">{{build.name}}</option>-->
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row m-b-sm" *ngIf="data.type == 'list'">
                    <div class="col-md-3 input-header">
                        Sort By
                        <i *ngIf="!showSorting"
                           class="fa fa-plus-circle mtv-primary-color m-t-7"
                           [ngStyle]="{'cursor' : data.fieldsToShow.length < 1 ? 'not-allowed' : ''}"
                           (click)="addSorting()">
                        </i>
                        <i *ngIf="showSorting"
                           class="fa fa-times-circle m-t-7"
                           aria-hidden="true"
                           (click)="hideSorting()">
                        </i>
                    </div>
                    <div class="col-md-3 input-header" *ngIf="showSorting">Sort By Direction</div>
                    <!--<div class="col-md-2 input-header">Page Orientation</div>-->
                    <!--<div class="col-md-2 input-header">Graph</div>-->
                </div>

                <div class="row m-b-md" *ngIf="data.type == 'list'">
                    <div class="col-md-3" *ngIf="showSorting">
                        <select class="form-control"
                                name="orderBy"
                                [(ngModel)]="data.orderBy"
                                (change)="reportGeneratorService.modalInfoWasChanged = true;"
                                [disabled]="reportGeneratorService.viewOnlyMode">
                            <option value="" hidden></option>
                            <option *ngFor="let field of data.fieldsToShow" [value]="field.key">{{field.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-3" *ngIf="showSorting">
                        <select class="form-control"
                                name="orderByDirection"
                                [(ngModel)]="data.orderByDirection"
                                (change)="reportGeneratorService.modalInfoWasChanged = true;"
                                [disabled]="reportGeneratorService.viewOnlyMode">
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                        </select>
                    </div>
                    <!--<div class="col-md-2">-->
                        <!--<select class="form-control" name="pageOrientation">-->
                            <!--<option value="" hidden></option>-->
                            <!--<option value="landscape">Landscape</option>-->
                            <!--<option value="portrait">Portrait</option>-->
                        <!--</select>-->
                    <!--</div>-->
                    <!--<div class="col-md-2">-->
                        <!--<select class="form-control" name="graph">-->
                            <!--<option value="" hidden></option>-->
                            <!--<option>Graph</option>-->
                            <!--&lt;!&ndash;<option *ngFor="let build of dailyReportsService.buildingsForUpdate" [value]="build.id">{{build.name}}</option>&ndash;&gt;-->
                        <!--</select>-->
                    <!--</div>-->
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-12 input-header">
                        Conditions
                        <i *ngIf="!showConditions"
                           class="fa fa-plus-circle mtv-primary-color m-t-7"
                           [ngStyle]="{'cursor' : data.fieldsToShow.length < 1 ? 'not-allowed' : ''}"
                           (click)="addConditions()">
                        </i>
                        <i *ngIf="showConditions"
                           class="fa fa-times-circle m-t-7"
                           aria-hidden="true"
                           (click)="showConditions = false;">
                        </i>
                    </div>
                </div>

                <div class="row m-b-md" *ngIf="showConditions">
                    <div class="col-md-3">
                        <select class="form-control"
                                name="key"
                                [(ngModel)]="newCondition.key"
                                [disabled]="reportGeneratorService.viewOnlyMode">
                            <option value="" hidden></option>
                            <option *ngFor="let condition of getFieldsWithConditions()" [value]="condition.key">
                                {{condition.name}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <select class="form-control"
                                name="condition"
                                [(ngModel)]="newCondition.condition"
                                (change)="onConditionChange($event)"
                                [disabled]="reportGeneratorService.viewOnlyMode">
                            <option value="" hidden></option>
                            <option *ngFor="let cond of getConditions()" [value]="cond.id">{{cond.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 directory-add-modal-date-field general-tab"
                         *ngIf="getFieldType()"
                         [ngClass]="{'report-generator-multiselect': getFieldType() == 'buildings' || getFieldType() == 'possibleValues'}">
                        <input *ngIf="getFieldType() == 'string'"
                               class="form-control"
                               name="value"
                               [(ngModel)]="newCondition.value">
                        <mat-form-field *ngIf="getFieldType() == 'date'">
                            <input matInput
                                   [(ngModel)]="newCondition.value"
                                   name="value"
                                   [matDatepicker]="datePicker"
                                   (focus)="datePicker.open()"
                                   (click)="datePicker.open()"
                                   placeholder="Choose a date"
                                   required>
                            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datePicker></mat-datepicker>
                        </mat-form-field>
                        <multiselect-field *ngIf="getFieldType() == 'buildings'"
                                           name="value"
                                           [editOnly]="true"
                                           [data]="reportGeneratorService.buildingsForMultiselect"
                                           [(ngModel)]="newCondition.value">
                        </multiselect-field>
                        <multiselect-field *ngIf="getFieldType() == 'possibleValues'"
                                           name="value"
                                           [editOnly]="true"
                                           [data]="possibleValues"
                                           [blankError]="'Values should not be blank.'"
                                           [(ngModel)]="newCondition.value">
                        </multiselect-field>
                    </div>
                    <div class="col-md-3" style="display: flex;">
                        <label class="img-checkbox m-r-lg">
                            <input type="checkbox"
                                   id="isRuntime" name="isRuntime"
                                   [(ngModel)]="newCondition.isRuntime"
                                   [disabled]="reportGeneratorService.viewOnlyMode">
                            <label class="with-checkbox clickable" for="isRuntime">
                                <svg-checked></svg-checked>
                                Runtime
                            </label>
                        </label>
                        <button type="button"
                                [disabled]="reportGeneratorService.viewOnlyMode"
                                (click)="addNewCondition()"
                                class="btn btn-outline-primary mtv-primary-color add-condition-button" >
                            Add Condition
                        </button>
                    </div>
                </div>
                <div class="row m-b-md" *ngFor="let condition of data.conditions; let index = index;">
                    <div class="col-md-6 remove-children-padding">
                        {{getConditionFieldName(condition.key)}} | {{getConditionName(condition.key, condition.condition)}} {{outputFormatting(condition) ? ('| ' + outputFormatting(condition)) : ''}}
                    </div>
                    <div class="col-md-3">
                        <span *ngIf="condition.isRuntime">Runtime</span>
                    </div>
                    <i *ngIf="!reportGeneratorService.viewOnlyMode"
                       class="fa fa-times-circle m-t-7"
                       aria-hidden="true"
                       (click)="removeCondition(index)">
                    </i>
                </div>
            </div>
            </div>
            </div>
            <div class="report-info">
                <div class="row">
                    <div class="col-md-4">
                        <button type="submit"
                                class="btn btn-outline-primary mtv-primary-color"
                                [disabled]="disabledSubmit || reportGeneratorService.viewOnlyMode"
                                (click)="saveReport(true)">
                            Save & Run
                        </button>
                        <button type="submit"
                                class="btn btn-primary submit-btn"
                                [disabled]="disabledSubmit || reportGeneratorService.viewOnlyMode"
                                (click)="saveReport(false)">
                            Save
                        </button>
                        <button type="button"
                                class="btn btn-outline-primary mtv-primary-color"
                                [disabled]="disabledSubmit"
                                (click)="hideModal()">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/report-generator-modal/report-generator-modal.component.html